
var encrypt_lookup = [
  "Z",
  "m",
  "s",
  "e",
  "r",
  "b",
  "B",
  "o",
  "H",
  "Q",
  "t",
  "N",
  "P",
  "+",
  "w",
  "O",
  "c",
  "z",
  "a",
  "/",
  "L",
  "p",
  "n",
  "g",
  "G",
  "8",
  "y",
  "J",
  "q",
  "4",
  "2",
  "K",
  "W",
  "Y",
  "j",
  "0",
  "D",
  "S",
  "f",
  "d",
  "i",
  "k",
  "x",
  "3",
  "V",
  "T",
  "1",
  "6",
  "I",
  "l",
  "U",
  "A",
  "F",
  "M",
  "9",
  "7",
  "h",
  "E",
  "C",
  "v",
  "u",
  "R",
  "X",
  "5"
];

let esm_typeof = {}
esm_typeof.A = function (t) {
  return typeof t
}

function encrypt_b64Encode(t) {
  var e = 664
    , r = 634
    , n = 448
    , o = 599
    , i = 315
    , a = 416
    , u = 512
    , s = 361
    , c = 406
    , l = 487
    , f = 496
    , p = 333
    , h = 630
    , d = 639
    , v = 548
    , g = 582
    , m = 447
    , y = 468
    , w = 375
    , b = 331
    , _ = 149
    , E = 382
    , x = 265
    , k = 625
    , T = 570
    , S = 551
    , A = 582
    , L = 581
    , I = 638
    , R = 618
    , O = 606
    , C = 429
    , N = 651
    , P = 667
    , B = 817
    , M = 333
    , j = 567
    , F = 747
    , D = 561
    , q = 570
    , U = 676
    , G = 840
    , H = 240
    , V = {
      udFrB: function (t, e) {
        return t % e
      },
      cCZFe: function (t, e) {
        return t === e
      },
      jevwl: function (t, e) {
        return t - e
      },
      aqlTy: function (t, e) {
        return t + e
      },
      rceYY: function (t, e) {
        return t >> e
      },
      OwjMq: function (t, e) {
        return t & e
      },
      kSGXO: function (t, e) {
        return t << e
      },
      veNiI: function (t, e) {
        return t === e
      },
      QLthP: function (t, e) {
        return t + e
      },
      wDtJz: function (t, e) {
        return t + e
      },
      nYqUQ: function (t, e) {
        return t & e
      },
      TCArD: function (t, e) {
        return t << e
      },
      RHteb: function (t, e) {
        return t - e
      },
      mZPJZ: function (t, e) {
        return t < e
      },
      zDETq: function (t, e, r, n) {
        return t(e, r, n)
      },
      YlZGp: function (t, e) {
        return t > e
      }
    };
  function W(t, e) {
    return a0_0x10f4ac(e, t - -H)
  }
  for (var X = (W(-413, -442) + W(-e, -r) + "7")[W(-n, -o)]("|"), z = 0; ;) {
    switch (X[z++]) {
      case "0":
        var Y;
        continue;
      case "1":
        var K = [];
        continue;
      case "2":
        var J = V[W(-i, -a)]($, 3);
        continue;
      case "3":
        var $ = t[W(-350, -u)];
        continue;
      case "4":
        V[W(-s, -c)](J, 1) ? (Y = t[V[W(-l, -f)]($, 1)],
          K[W(-p, -346)](V[W(-h, -d)](encrypt_lookup[V[W(-503, -v)](Y, 2)] + encrypt_lookup[V[W(-g, -741)](V[W(-331, -m)](Y, 4), 63)], "=="))) : V[W(-y, -w)](J, 2) && (Y = V[W(-b, -_)](t[$ - 2], 8) + t[V[W(-l, -E)]($, 1)],
            K[W(-333, -x)](V[W(-k, -505)](V[W(-T, -S)](encrypt_lookup[Y >> 10], encrypt_lookup[V[W(-A, -L)](Y >> 4, 63)]) + encrypt_lookup[V[W(-I, -R)](V[W(-O, -C)](Y, 2), 63)], "=")));
        continue;
      case "5":
        var Q = 16383;
        continue;
      case "6":
        for (var Z = 0, tt = V[W(-509, -N)]($, J); V[W(-P, -B)](Z, tt); Z += Q)
          K[W(-M, -153)](V[W(-j, -F)](encrypt_encodeChunk, t, Z, V[W(-D, -413)](Z + Q, tt) ? tt : V[W(-q, -501)](Z, Q)));
        continue;
      case "7":
        return K[W(-U, -G)]("")
    }
    break
  }
}

function encrypt_encodeUtf8(t) {
  var e = 185
    , r = 410
    , n = 480
    , o = 222
    , i = 194
    , a = 165
    , u = 147
    , s = 290
    , c = 460
    , l = 472
    , f = 497
    , p = 462
    , h = 286
    , d = 209
    , v = 223
    , g = 590
    , m = {
      bIGxm: function (t, e) {
        return t(e)
      },
      MahgM: function (t, e) {
        return t < e
      },
      czxKn: function (t, e) {
        return t === e
      },
      clYIu: function (t, e) {
        return t + e
      }
    }
    , y = m[b(477, 488)](encodeURIComponent, t)
    , w = [];
  function b(t, e) {
    return a0_0x10f4ac(t, e - g)
  }
  for (var _ = 0; m[b(333, e)](_, y[b(r, n)]); _++) {
    var E = y[b(o, 290)](_);
    if (m[b(i, a)](E, "%")) {
      var x = y[b(u, s)](m[b(574, 472)](_, 1)) + y[b(c, 290)](m[b(605, l)](_, 2))
        , k = parseInt(x, 16);
      w[b(592, f)](k),
        _ += 2
    } else
      w[b(p, f)](E[b(217, h) + b(d, v)](0))
  }
  return w
}

function sign_common(h) {
    return encrypt_b64Encode(encrypt_encodeUtf8(JSON.stringify(h)))
}
function encrypt_tripletToBase64(t) {
  var e = 11
    , r = 15
    , n = 199
    , o = 34
    , i = 4
    , a = 102
    , u = 276
    , s = 205
    , c = 218
    , l = 11
    , f = 115
    , p = 34
    , h = 161
    , d = 123
    , v = 335
    , g = {};
  function m(t, e) {
    return a0_0x10f4ac(e, t - v)
  }
  g[m(205, 328)] = function (t, e) {
    return t + e
  }
    ,
    g[m(e, 53)] = function (t, e) {
      return t >> e
    }
    ,
    g[m(r, n)] = function (t, e) {
      return t & e
    }
    ,
    g[m(o, i)] = function (t, e) {
      return t >> e
    }
    ,
    g[m(-a, -u)] = function (t, e) {
      return t & e
    }
    ;
  var y = g;
  return y[m(s, c)](encrypt_lookup[63 & y[m(l, -75)](t, 18)], encrypt_lookup[y[m(r, f)](y[m(p, h)](t, 12), 63)]) + encrypt_lookup[t >> 6 & 63] + encrypt_lookup[y[m(-a, -d)](t, 63)]
}
function encrypt_encodeChunk(t, e, r) {
  var n, o = 165, i = 246, a = 205, u = 353, s = 162, c = 17, l = 351, f = 191, p = 139, h = 79, d = 86, v = 233, g = 270, m = 166, y = {
    hwomB: function (t, e) {
      return t < e
    },
    iHUeL: function (t, e) {
      return t & e
    },
    ELxEv: function (t, e) {
      return t << e
    },
    lBuRH: function (t, e) {
      return t << e
    },
    SkIJl: function (t, e) {
      return t & e
    },
    JYxWY: function (t, e) {
      return t + e
    },
    CxjtF: function (t, e) {
      return t(e)
    }
  }, w = [];
  function b(t, e) {
    return a0_0x10f4ac(t, e - m)
  }
  for (var _ = e; y[b(-63, -o)](_, r); _ += 3)
    n = y[b(-i, -a)](y[b(-166, -124)](t[_], 16), 16711680) + y[b(-u, -205)](y[b(s, -c)](t[_ + 1], 8), 65280) + y[b(-l, -208)](t[y[b(-350, -f)](_, 2)], 255),
      w[b(p, 73)](y[b(h, d)](encrypt_tripletToBase64, n));
  return w[b(-v, -g)]("")
}

function a0_0x3693(t, e) {
  var r = [
    "xUKNL",
    "jUrZI",
    "rviFu",
    "join",
    "get",
    "LjDtD",
    "ZJHyP",
    "wOmGY",
    "enumera",
    "aONWR",
    "string",
    "kQpMi",
    "mZPJZ",
    "Ysiay",
    "czxKn",
    "|5|6|4|",
    "prototy",
    "jklmnop",
    "MuYbw",
    "diDwk",
    "TRFtx",
    "drDHI",
    "WLARA",
    "xyz0123",
    "asBytes",
    "|6|0|1|",
    "JOtEi",
    "Oialn",
    "OQrEi",
    "uPnXq",
    "VWXYZab",
    "cIbFa",
    "qYuta",
    "QDOZZ",
    "MahgM",
    "iRXZq",
    "22098XlFGYn",
    "mmLKn",
    "jMcIE",
    "stringi",
    "[object",
    "nYqUQ",
    "jSgjk",
    "ucyEo",
    "iewJI",
    "vgTwl",
    "DnNGR",
    "oBytes",
    "Xtwzk",
    "aqlTy",
    "JWnPK",
    "1|0|2|4",
    "qrstuvw",
    "_gg",
    "QLthP",
    "FJIWy",
    "yRnhISG",
    "pjUsr",
    "KAwuh",
    "Thhoa",
    "jarkJ",
    "WjRNN",
    "asStrin",
    "x3VT16I",
    "357835LaQWjW",
    "SkIJl",
    "size",
    "iyorr",
    "iHUeL",
    "tTanW",
    "tNusJ",
    "NiSrP",
    "eAt",
    "TCArD",
    "a2r1ZQo",
    "iamspam",
    "bOnfu",
    "UNSKg",
    "HIJKLMN",
    "ZfMKC",
    "bJhXU",
    "zwAAc",
    "JYxWY",
    "lUAFM97",
    "mwaRe",
    "EzYWD",
    "replace",
    "uOtUJ",
    "__esMod",
    "ViQWI",
    "aCMFL",
    "EAKSd",
    "ule",
    "pqnFP",
    "qYDsL",
    "270726pnaYfG",
    "glBZG",
    "OwjMq",
    "YGrjc",
    "ZhAcd",
    "JDqFL",
    "456789+",
    "kEjQs",
    "lWhbD",
    "OaLTI",
    "dXlgm",
    "cVte9UJ",
    "ctor",
    "hwomB",
    "wDtJz",
    "constru",
    "ABHuC",
    "zDETq",
    "SYNeA",
    "BGbij",
    "ionFq",
    "QzaNS",
    "7|3|5|4",
    "YlZGp",
    "Bjniw",
    "ZITuN",
    "KPTzH",
    "HrBeq",
    "xobsT",
    "kXJkC",
    "QSrEZ",
    "ENXtO",
    "FYbRJ",
    "wOcza/L",
    "_hh",
    "dVXMb",
    "ppkua",
    "WgamZ",
    "HuwCW",
    "362424fnLCuh",
    "charCod",
    "HhPqg",
    "ODunI",
    "eJzqq",
    "charAt",
    "JGAgI",
    "ZmserbB",
    "TURcG",
    "WyrqF",
    "iYJzH",
    "VIwfH",
    "tzzOB",
    "YgiCH",
    "byyMQ",
    "ELxEv",
    "0DSfdik",
    "HRihr",
    "_ii",
    "aDsrp",
    "ble",
    "jTGtW",
    "configu",
    "cXiYW",
    "56kSpAsC",
    "158KIldlA",
    "oHQtNP+",
    "BHavO",
    "PCIlh",
    "QatIf",
    "IKyqh",
    "Words",
    "Qwnrg",
    "44lQAgNu",
    "cdefghi",
    "nTwxD",
    "RHteb",
    "coqPr",
    "rJwmI",
    "aBoeK",
    "default",
    "exports",
    "rceYY",
    "isArray",
    "mdKKO",
    "kzxWE",
    "DeBtm",
    "tjjUn",
    "vJEcD",
    "LpfE8xz",
    "bin",
    "HKazo",
    "rable",
    "call",
    "wordsTo",
    "zBiyt",
    "GrsGL",
    "fqulF",
    "jevwl",
    "mxfLj",
    "xlUnt",
    "q42KWYj",
    "endian",
    "eEqDc",
    "oyGAZ",
    "bytesTo",
    "OzjuJ",
    "IfwWq",
    "ize",
    "6648810piiNEz",
    "lTHdy",
    "vDLZJ",
    "stringT",
    "A4NjFqY",
    "GkjTz",
    "eooJA",
    "substr",
    "veNiI",
    "LYfDp",
    "ljKsP",
    "jJYWG",
    "bcYAf",
    "srikB",
    "utf8",
    "qTbeY",
    "yqRzd",
    "|3|5",
    "bjbAy",
    " Array]",
    "rMbXP",
    "u5wPHsO",
    "test",
    "gMIMC",
    "Deyqv",
    " argume",
    "ABCDEFG",
    "undefin",
    "split",
    "QTlsj",
    "_isBuff",
    "OPQRSTU",
    "Illegal",
    "loSen",
    "navigat",
    "ObwNo",
    "qPbcq",
    "7182692QogvXX",
    "tvqSn",
    "DGptJ",
    "HhTfW",
    "avIYx",
    "defineP",
    "PFQbW",
    "CjFyM",
    "toStrin",
    "yMWXS",
    "yMyOy",
    "0XTdDgM",
    "eXkru",
    "_blocks",
    "indexOf",
    "mbBQr",
    "lBuRH",
    "HzGjH",
    "HNErV",
    "mEokX",
    "userAge",
    "UpmtD",
    "sgomx",
    "KDfKS",
    "OTbSq",
    "lxMGW",
    "0|3|2|1",
    "dfWyB",
    "lWzAd",
    "eyXTL",
    "5624qreyZK",
    "pow",
    "IJstz",
    "LMlMB",
    "INlwI",
    "lRulU",
    "TCgZh",
    "_digest",
    "UBhIl",
    "fLtZZ",
    "FYSKq",
    "2|8|0",
    "IoCeZ",
    " Object",
    "UuTvI",
    "lNKLD",
    "String",
    "Bytes",
    "rBVvW",
    "KblCWi+",
    "pRaIH",
    "roperty",
    "vTINI",
    "atLE",
    "functio",
    "Udqoy",
    "nt ",
    "htSWx",
    "hEwRK",
    "encodin",
    "sCSVK",
    "VuAZF",
    "xeIIy",
    "RBjMb",
    "taTrq",
    "vDLFJ",
    "bPkya",
    "HzimH",
    "nCffO",
    "BWbtU",
    "2|8",
    "slice",
    "lxMGQ",
    "tTiwe",
    "JDhJB",
    "rCode",
    "gNDzY",
    "wJkyu",
    "cCZFe",
    "RNGSl",
    "floor",
    "clYIu",
    "vLiwz",
    "BiNSE",
    "MtYWB",
    "fromCha",
    "StNOc",
    "|7|5|3|",
    "9|1|4|6",
    "length",
    "UNYAE",
    "pngG8yJ",
    "hasOwnP",
    "pYeWu",
    "wTjkk",
    "Bvk6/7=",
    "KTmgk",
    "bIGxm",
    "readFlo",
    "LFZch",
    "_ff",
    "1|3|4|2",
    "binary",
    "LLdJZ",
    "ZofOU",
    "6399uFPxTQ",
    "push",
    "YntPT",
    "kSGXO",
    "random",
    "HfpCU",
    "hECvuRX",
    "getTime",
    "iwSyV",
    "alert",
    "LKMcb",
    "DJVdg",
    "Hex",
    "URzKO",
    "CxjtF",
    "ZVOCs",
    "isBuffe",
    "vGpbT",
    "rotl",
    "udFrB",
    "CnbsH",
    "crLST"
  ]
  return r[t -= 131]
}
function a0_0x10f4ac(t, e) {
  return a0_0x3693(e - -570, t)
}

var encrypt_mcr = function (t) {
  var e = 67
    , r = 15
    , n = 164
    , o = 126
    , i = 137
    , a = 39
    , u = 176
    , s = 72
    , c = 56
    , l = 21
    , f = 35
    , p = 34
    , h = 35
    , d = 18
    , v = 25
    , g = 185
    , m = 1149
    , y = 744
    , w = 1295
    , b = 1248
    , _ = 1310
    , E = 1096
    , x = 1166
    , k = 1095
    , T = 1196
    , S = 1180
    , A = 1039
    , L = 976
    , R = 1347
    , I = 1117
    , O = 1168
    , C = 1233
    , N = 1157
    , P = 1006
    , B = 1122
    , M = 1277
    , j = 1288
    , F = 1271
    , D = 986
    , q = 162
    , U = {};
  function H(t, e) {
    return a0_0x10f4ac(e, t - q)
  }
  U[H(-73, -66)] = function (t, e) {
    return t === e
  }
    ,
    U[H(e, 186)] = function (t, e) {
      return t < e
    }
    ,
    U[H(-r, -n)] = function (t, e) {
      return t ^ e
    }
    ,
    U[H(r, -o)] = function (t, e) {
      return t & e
    }
    ,
    U[H(-i, -a)] = function (t, e) {
      return t < e
    }
    ,
    U[H(-175, -u)] = function (t, e) {
      return t ^ e
    }
    ,
    U[H(-59, s)] = function (t, e) {
      return t ^ e
    }
    ,
    U[H(-c, -l)] = function (t, e) {
      return t >>> e
    }
    ,
    U[H(f, p)] = function (t, e) {
      return t >>> e
    }
    ;
  for (var G, V, W = U, z = 3988292384, X = 256, Y = []; X--; Y[X] = W[H(h, -66)](G, 0))
    for (V = 8,
      G = X; V--;)
      G = W[H(r, d)](G, 1) ? W[H(35, v)](G, 1) ^ z : W[H(h, g)](G, 1);
  return function (t) {
    function e(t, e) {
      return H(e - 1181, t)
    }
    if (W[e(m, 1108)]((0,
      esm_typeof.A)(t), e(y, 914))) {
      for (var r = 0, n = -1; W[e(w, b)](r, t[e(_, 1233)]); ++r)
        n = W[e(E, x)](Y[W[e(k, T)](n, 255) ^ t[e(S, A) + e(1022, L)](r)], n >>> 8);
      return W[e(R, 1166)](n, -1) ^ z
    }
    for (r = 0,
      n = -1; W[e(I, 1044)](r, t[e(O, C)]); ++r)
      n = W[e(N, P)](Y[W[e(1229, B)](W[e(M, T)](n, 255), t[r])], W[e(j, 1125)](n, 8));
    return W[e(F, B)](W[e(D, 1122)](n, -1), z)
  }
}();

function GenXSCommon(a1cookie, x_t, x_s) {
    let b1 = 'I38rHdgsjopgIvesdVwgIC+oIELmBZ5e3VwXLgFTIxS3bqwErFeexd0ekncAzMFYnqthIhJeSnMDKutRI3KsYorWHPtGrbV0P9WfIi/eWc6eYqtyQApPI37ekmR1QL+5Ii6sdnoeSfqYHqwl2qt5B0DoIvMzOZQqZVw7IxOeTqwr4qtiIkrOIi/skccxICLdI3Oe0utl2ADZsLveDSKsSPw5IEvsiutJOqw8BVwfPpdeTDWOIx4VIiu6ZPwbPut5IvlaLbgs3qtxIxes1VwHIkumIkIyejgsY/WTge7sjutKrZgedWI9gfKeYWZGI36eWPwyIEJefut0ocVAPBLLI3Aeiqt3cZ7sVom4IESyIhEqQd4AICY24F4gIiifpVwAICZVJo3sWWJs1qwiIvdef97e0ekKIi/e1piS8qwUIE7s1fds6WAeiVwqed5sdut3IxILbd6sdqtDbgKs0PwgIv8aI3z5rqwGBVtwzfTsKD7sdBdskut+Iioed/As1SiiIkKs0F6s3nVuIkge1Pt0IkVkwPwwNVtMI3/e1qtdIkKs1VwVIEesdutA+qwKsuw7IvrRIxDgJfIj2IJexVtVIhiKIi6eDVw/bz4zLadsYjmfIkWo4VtPmVw5IvAe3qtk+LJeTl5sTSEyIEJekdgs3PtsnPwqI35sSPt0Ih/sV04TIk0ejjNsfqw7Iv3sVut04B8qIkWyIvKsxFOekzNsdAKsYPtKIiMFI3MurVtKIvzjIh6s6lFut//sWqtaI3IYbuwl'
    let h = {
      "s0": 3,
      "s1": "",
      "x0": "1",
      "x1": "3.6.8",
      "x2": "Mac OS",
      "x3": "xhs-pc-web",
      "x4": "4.20.1",
      "x5": a1cookie, // a1 cookie
      "x6": x_t,
      "x7": x_s,
      "x8": b1,
      "x9": encrypt_mcr(x_t + x_s + b1),
      "x10": 1,
    }

    return sign_common(h)
}

module.exports = GenXSCommon


// let a1 = '195b24e679dmxgripk2o89yld9kdnoklz0h04octb40000365251';
// let x_t = 1754108104611;
// const x_s = 'XYS_2UQhPsHCH0c1PjhFHjIj2erjwjQM89PjNsQhPjHCHDlkJdphHjIj2ePjwjQTJdPIP/ZlgAmGy0Yt4Lh3cFq34DE84F+ewBrM/9IUwebz8F+3J9Qi+SQD8dzN4e8EPeYS2eb7c0mTc9Yrc7z14nI3nLkQcDSenLkG4sR68FVM+nSF2e+NJ9zca0mkzrTj4DV3GMqMpoS3yeWEznbM+L40wn4Lpbb9zr+7/SW6PMYYzeQ1aFTI8gm8J/YL/FzTc0D6zgSyPjTy+0Ys+7c38g8NLSQD8AWjNsQh+sHCHfRjyfp04sQR'

// console.log(GenXSCommon(a1, x_t, x_s));
